import { render, staticRenderFns } from "./dun.vue?vue&type=template&id=315ec172"
import script from "./dun.vue?vue&type=script&lang=js"
export * from "./dun.vue?vue&type=script&lang=js"
import style0 from "./dun.vue?vue&type=style&index=0&id=315ec172&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports